




import Blockly from 'blockly'
import * as javascript from 'blockly/javascript'
import * as Ja from 'blockly/msg/ja'
import { defineComponent, onMounted, ref, inject } from '@vue/composition-api'
import CustomCategory from '../plugins/blockly_custom_category'
import { key } from '../store'

export default defineComponent({
  name: 'Block',
  setup() {
    const store = inject(key)
    if (!store) {
      throw new Error('')
    }
    let workspace = ref<Blockly.WorkspaceSvg>()
    let blocklyCommands = ref('')

    const createTheme = (): Blockly.Theme => {
      // Blockly.HSV_SATURATION = 0.8
      // Blockly.HSV_VALUE = 1
      {/* @ts-ignore */} // eslint-disable-line
      const baseTheme = Blockly.Themes.Deuteranopia
      const thema = Blockly.Theme.defineTheme('customize_theme', {
        base: baseTheme,
        blockStyles: {
          logic_blocks: {
            colourPrimary: '#20e6d8',
            colourSecondary: '#20e6d8',
            colourTertiary: '#20e6d8',
          },
          loop_blocks: {
            colourPrimary: '#20e6d8',
            colourSecondary: '#20e6d8',
            colourTertiary: '#20e6d8',
          },
          math_blocks: {
            colourPrimary: '#83e620',
            colourSecondary: '#83e620',
            colourTertiary: '#83e620',
          },
        },
      })
      return thema
    }

    onMounted(() => {
      Blockly.registry.register(Blockly.registry.Type.TOOLBOX_ITEM, Blockly.ToolboxCategory.registrationName, CustomCategory, true)
      Blockly.setLocale(Ja)
      Blockly.defineBlocksWithJsonArray([
        { type: 'meirei', message0: 'めいれい %1', args0: [{ type: 'input_statement', name: 'commands' }], colour: '#20e6db', tooltip: '', helpUrl: '' },
        { type: 'pose_human', message0: '%1', args0: [{ type: 'field_image', src: '/img/pose_blocks/pose_human.png', width: 100, height: 100, alt: '直立したポーズ', flipRtl: false }], previousStatement: null, nextStatement: null, colour: '#2090e6', tooltip: '', helpUrl: '' },
        { type: 'pose_lion', message0: '%1', args0: [{ type: 'field_image', src: '/img/pose_blocks/pose_lion.png', width: 100, height: 100, alt: 'ライオンのように肘を曲げて両手を挙げたポーズ', flipRtl: false }], previousStatement: null, nextStatement: null, colour: '#2090e6', tooltip: '', helpUrl: '' },
        { type: 'pose_bird', message0: '%1', args0: [{ type: 'field_image', src: '/img/pose_blocks/pose_bird.png', width: 100, height: 100, alt: 'トリのように両手を伸ばして挙げたポーズ', flipRtl: false }], previousStatement: null, nextStatement: null, colour: '#2090e6', tooltip: '', helpUrl: '' },
        { type: 'pose_rabbit', message0: '%1', args0: [{ type: 'field_image', src: '/img/pose_blocks/pose_rabbit.png', width: 100, height: 100, alt: 'ウサギのように手を耳に当てるポーズ', flipRtl: false }], previousStatement: null, nextStatement: null, colour: '#2090e6', tooltip: '', helpUrl: '' },
      ])
      workspace.value = Blockly.inject('blocklyDiv', {
        zoom: { controls: true },
        move: {
          scrollbars: false,
        },
        renderer: 'thrasos',
        toolbox: `
            <xml>
              <category name="" colour="#2090E6" css-icon="pose-icon">
                <block type="pose_human"></block><block type="pose_lion"></block><block type="pose_bird"></block><block type="pose_rabbit"></block>
              </category>
              <category name="" colour="#20E6D8" css-icon="logic-icon">
                <block type="meirei"></block>
                <block type="controls_if"></block>
                <block type="logic_compare">
                  <field name="OP">EQ</field>
                </block>
                <block type="logic_operation">
                  <field name="OP">AND</field>
                </block>
                <block type="controls_repeat_ext">
                  <value name="TIMES">
                    <shadow type="math_number">
                      <field name="NUM">10</field>
                    </shadow>
                  </value>
                </block>
              </category>
              <category name="" colour="#83E620" css-icon="math-icon">
                <block type="math_number">
                  <field name="NUM">0</field>
                </block>
                <block type="math_arithmetic">
                  <field name="OP">ADD</field>
                  <value name="A">
                    <shadow type="math_number">
                      <field name="NUM">1</field>
                    </shadow>
                  </value>
                  <value name="B">
                    <shadow type="math_number">
                      <field name="NUM">1</field>
                    </shadow>
                  </value>
                </block>
                <block type="math_number_property">
                  <mutation divisor_input="false"></mutation>
                  <field name="PROPERTY">EVEN</field>
                  <value name="NUMBER_TO_CHECK">
                    <shadow type="math_number">
                      <field name="NUM">0</field>
                    </shadow>
                  </value>
                </block>
                <block type="math_round">
                  <field name="OP">ROUND</field>
                  <value name="NUM">
                    <shadow type="math_number">
                      <field name="NUM">3.1</field>
                    </shadow>
                  </value>
                </block>
                <block type="math_single">
                  <field name="OP">ROOT</field>
                  <value name="NUM">
                    <shadow type="math_number">
                      <field name="NUM">9</field>
                    </shadow>
                  </value>
                </block>
              </category>
            </xml>
          `,
      })

      if (store.state.blocklyTheme === null) {
        store.setBlocklyTheme(createTheme())
      }
      if (store.state.blocklyTheme) {
        workspace.value.setTheme(store.state.blocklyTheme)
      }
      {/* @ts-ignore */} // eslint-disable-line
      javascript['meirei'] = (block) => {
        const commands = javascript.statementToCode(block, 'commands')
        blocklyCommands.value = commands
        return ''
      }
      {/* @ts-ignore */} // eslint-disable-line
      javascript['pose_human'] = () => {
        return 'outputs.push("ヒト");'
      }
      {/* @ts-ignore */} // eslint-disable-line
      javascript['pose_lion'] = () => {
        return 'outputs.push("ライオン");'
      }
      {/* @ts-ignore */} // eslint-disable-line
      javascript['pose_bird'] = () => {
        return 'outputs.push("トリ");'
      }
      {/* @ts-ignore */} // eslint-disable-line
      javascript['pose_rabbit'] = () => {
        return 'outputs.push("ウサギ");'
      }
    })
    function output(): Array<string> {
      const outputs: string[] = []
      javascript.workspaceToCode(workspace.value)
      eval(blocklyCommands.value)
      return outputs
    }

    function blockToCode(): string {
      if (!workspace.value) {
        return ''
      }
      const xml = Blockly.Xml.workspaceToDom(workspace.value)
      return Blockly.Xml.domToText(xml)
    }

    function initializeBlock(code: string): void {
      if (!workspace.value) {
        return
      }
      if (code === '') {
        code = '<xml xmlns="https://developers.google.com/blockly/xml"><block type="meirei" id="sm?b{k~o)nf}WX_|SrLp" x="-113" y="-75"></block></xml>'
      }
      const xml = Blockly.Xml.textToDom(code)
      Blockly.Xml.domToWorkspace(xml, workspace.value)
    }

    return {
      output,
      blockToCode,
      initializeBlock,
    }
  },
})
